export default __webpack_public_path__ + "static/27-7984d3f31f4ff7f5a205b53d66715151.jpg";